module.exports = __webpack_public_path__ + "img/ic-chevron-up-black.4563a8ce.svg";